const dictionary = {
  en: {
    messages: {
      required: () => 'This is a required field.'
    },
    custom: {
    }
  }
}

export default dictionary



// WEBPACK FOOTER //
// ./src/assets/validation-messages.js